import { CommissionRulesQuery } from './query.types'

export const DEFAULT_COMMISSION_RULES_QUERY: CommissionRulesQuery = {
  limit: 50,
}
